module.exports = __webpack_public_path__ + "img/20wjhz-gif.45a94431.svg";